// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Dk-z","red":"Ek-z","calloutlink":"Fk-z","headerTopBanner":"Gk-z","bgcolorRed":"Hk-z","headerTopCallout":"Ik-z","searchBanner":"Jk-z","hideMobile":"Kk-z"};